module.exports = __webpack_public_path__ + "static/media/banner-amazon-6pay@3x.d17ef51b.png";